import angular from 'angular';

import authenticationService from '../../services/authentication.service.js';

import loginController from './login.controller.js';

export default angular.module('components.login', [authenticationService])
    .component('login', {
        template: require('./login.pug')(),
        controller: loginController
    })
    .component('loginForm', {
        template: require('./loginForm.pug')(),
        controller: loginController
    })
    .component('logout', {
        template: require('./logout.pug')(),
        controller: loginController
    })
    .name; 
